import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router, {resetRouter} from '../router.js'
import uploadUrl from '@/utils/uploads.js'
import md5 from 'md5'
import store from '@/store/index.js'
// let ROOT = ''
// if(process.env.VUE_APP_GRALIC === 'development') {
// 	ROOT = 'http://feature-houtaifadouyin-20210825-wisdom.fat.doutuimao.net'
// } else if(process.env.VUE_APP_GRALIC === 'test') {
// 	ROOT = 'http://wisdom.fat.doutuimao.net'
// } else {
// 	ROOT = 'http://wisdom.doutuimao.net'
// }
import staticPathTitle,{ getBaseUrl, staticPath } from '@/utils/baseUrl.js'
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = getBaseUrl()
Vue.axios.defaults.withCredentials = false
Vue.axios.defaults.headers = {
	'Content-Type': 'application/json',
	// token: localStorage.getItem('token')
	// token: localStorage.getItem('token'),
}

let noLoadingUrlList = ['/user/user/onlineproduct/productupdate','/user/upload/index', '/material/add', '/user/user/singleindex', '/login/login/editinfo', '/user/user/send/sms', '/user/user/check/master/pwd', '/user/user/check/sms/code', '/customer/preserve/method/course', '/customer/preserve/method/info', '/user/upload/getalltoken','/user/user/showlist','user/talent/codelist', '/login/login/checkwechat','/user/user/showlist','/author/course/getcourse', '/user/user/searchtalent', '/pay/checkorder','/qualification/share_author_list','/user/dy/group/imgstatus', '/user/dy/group/logininfov2','/message/member/msginfo','/message/member/msginfo/read','/message/fast/reply/group','/message/cards','/message/fast/reply','/message/send/message','/message/member', '/login/login/account/is_show_mobile']
let noScrennList = ['/material/index', '/author/course/index', '/author/show/index', '/user/order/detail', '/problem/list', '/pay/prepayurl']
let isMoreCancelUrl  = ['/author/show/index', '/author/course/index','/user/user/showlist','/user/user/info']

let cancelUrlObj = {}
let requestObj = {}

export function sendPost(url, data = {},methods="post", defaultHeaders, extraErrobj={},config={}) {
	let errObj = {
		showText: true, // 显示报错信息
		backAllErrObj: false, // 返回完整报错响应数据
		...extraErrobj
	}
	if(!noLoadingUrlList.includes(url) && store.state.isLoading !== 'cancle') {
		requestObj[url] = url
		noScrennList.includes(url) ? store.commit('changeLoading', 'noFullScreen') : store.commit('changeLoading', true)
	}
	if(cancelUrlObj[url]) {
		new Vue().cancelRequestT(cancelUrlObj[url])
	}
  return new Promise((resolve, reject) => {
	if(!noLoadingUrlList.includes(url) && store.state.isLoading !== 'cancle') {
		noScrennList.includes(url) ? store.commit('changeLoading', 'noFullScreen') : store.commit('changeLoading', true)
	}
	    axios[methods](url, {
		...{
			headers: defaultHeaders,
			cancelToken: new axios.CancelToken(c => {
				isMoreCancelUrl.includes(url) ? cancelUrlObj[url] = c : ''
			})
		},
		...(methods.toLowerCase() === 'get' ? { params: data } : { ...data }),
		...config // 支持自定义配置，如 responseType: 'blob'
	})
      .then(response => {
	// else if(url.includes(uploadUrl)) {
	// 	resolve(response.data)
	// }
	requestObj.hasOwnProperty(url)?  delete requestObj[url]: ''
	if(Object.keys(requestObj).length === 0) {
		store.commit('changeLoading', false)
	}
	// 如果配置了 responseType: 'blob'，说明是下载文件，不走 code 判断逻辑
    if (config.responseType === 'blob') {
        resolve(response);
        return;
    }
	        if (response.data.code == 0) {
	          resolve(response.data.data)
	        } else if (response.data.code == 413) {
				resetRouter()
				// Vue.prototype.$message.error(response.data.message || response.data.msg)
				Vue.prototype.$message({
					message: response.data.message || response.data.msg,
					type: 'error',
					duration: 4500
				})
				localStorage.removeItem('token')
				localStorage.removeItem('name')
				localStorage.removeItem('avatar_url')
				localStorage.removeItem('desc')
				localStorage.removeItem('breadCrumbList')
				localStorage.removeItem('institution')
				store.commit('permission/getMenuTreeList', [])
				store.commit('message/changeWaitCount', {})
				router.replace(staticPath +'login')
			} else {
				// Vue.prototype.$message.error(response.data.message || response.data.msg)
				if(errObj.showText){
					Vue.prototype.$message({
						message: response.data.message || response.data.msg,
						type: 'error',
						duration: 4500
					})
				}
				if(errObj.backAllErrObj){
					reject(response.data)
				}else{
					reject(response.data.message || response.data.msg)
				}
			}
      })
      .catch(err => {
		requestObj.hasOwnProperty(url)?  delete requestObj[url]: ''
		Vue.prototype.allIsLoading = false
        reject(err);
      });
  });
}
const errorFn = err => {
	if (err.toString().indexOf('timeout') !== -1) {
		Vue.prototype.$message.error('请求超时，请稍后再试')
		store.commit('changeLoading', false)
	}
	if(err.toString().includes('Network Error')) {
		Vue.prototype.$message.error('网络错误（Network Error）')
		store.commit('changeLoading', false)
	}
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				err.message = '请求错误'
				break

			case 401:
				err.message = '未授权，请登录'
				break

			case 403:
				err.message = '拒绝访问'
				break

			case 404:
				err.message = `请求地址出错: ${err.response.config.url}`
				break

			case 408:
				err.message = '请求超时'
				break

			case 500:
				err.message = '服务器开个小差，请稍后再试'
				break

			case 501:
				err.message = '服务器开个小差，请稍后再试'
				break

			case 502:
				err.message = '服务器开个小差，请稍后再试'
				break

			case 503:
				err.message = '服务器开个小差，请稍后再试'
				break

			case 504:
				err.message = '服务器开个小差，请稍后再试'
				break

			case 505:
				err.message = 'HTTP版本不受支持'
				break

			default:
				err.message = '请求失败，请稍后再试'
		}
		Vue.prototype.$message.error(err.message)
		store.commit('changeLoading', false)
	}
	// store.commit('changeLoading', false)
	return Promise.reject(err)
}
/* ***此处开始封装不同后台下的axios实例 ****/
Vue.axios.interceptors.request.use(
	config => {
		let token = localStorage.getItem('token')
		if(token) {
			let timeStamp = Date.now()
			config.headers.token = token
			config.headers.times = timeStamp
			config.headers.sign = md5(timeStamp + token)
		}
		// let comeFromObj = {
		// 	[staticPath+ 'dyAccountIndex']: 1,
		// 	[staticPath+ 'ksAccountIndex']: 2
		// }
		config.headers['come-from'] = config.headers['come-from'] ? config.headers['come-from']: staticPathTitle[staticPath].value
		// if(!comeFromObj[location.pathname]) {
		// 	config.headers['come-from'] = staticPath === '/' ? 1: 2
		// } else {
		// 	config.headers['come-from'] = comeFromObj[location.pathname]
		// }
		if(config.url.includes('https://imgadmin.doutuimao.net')) {
			if(config.headers.hasOwnProperty('token')) {
				config.headers = {}
			}
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
Vue.axios.interceptors.response.use(response => {
	if (response.data.code === 303) {
	}
	// console.log(response)
	return response
}, errorFn)
